import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// Styles
import './Header.css';
// Icons
import logo from '../../assets/thon-blue.png';
import noFlag from '../../assets/no-flag.png';
import enFlag from '../../assets/en-flag.png';
// Intl
import { FormattedMessage, injectIntl } from "react-intl";
import { setLocale } from '../../actions/actionCreators';
import { Helmet } from 'react-helmet';

class Header extends React.Component {
    render() {
        return (
            <div className="header">
                <Helmet>
                    <title>{this.props.intl.formatMessage({id: "pageTitle"})}</title>
                </Helmet>
                <div role="button" className="lang-flags">
                    <span className={this.props.lang === 'no' ? 'lang-active' : ''} onClick={() => this.props.setLocale('no')}>
                        <img src={noFlag} alt="Norwgian language" />
                    </span>
                    <span className={this.props.lang === 'en' ? 'lang-active' : ''} onClick={() => this.props.setLocale('en')}>
                        <img src={enFlag} alt="English language" />
                    </span>
                </div>
                <a href="/"> {/*http://www.olavthon.no/*/}
                    <img src={logo} className="thon-logo" alt="logo" />
                </a>
                <h1 className="header-title">
                    <FormattedMessage id="headerTitle" defaultMessage="Title" />
                </h1>
            </div>
        );
    }
}

Header.propTypes = {
    setLocale: PropTypes.func.isRequired
}

let mapStateToProps = state => ({
    inquiryTypes: state.inquiryTypes
});

export default injectIntl(connect(
    mapStateToProps,
    { setLocale }
)(Header));